import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuTransferDetailsTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].transferDetails) {
      if (key === 'gradingOfTransferredEmbryos') {
        return ['N/A', 'N/A', 'N/A'];
      }
      return 'N/A';
    }

    if (
      !data[index] ||
      data[index].transferDetails[key] === null ||
      data[index].transferDetails[key] === ''
    ) {
      if (key === 'gradingOfTransferredEmbryos') {
        return ['N/A', 'N/A', 'N/A'];
      }
      return 'N/A';
    }

    if (key === 'dayOfEmbryoCulture') {
      return data[index].transferDetails.embryoTransferredData[0].culture === ''
        ? 'N/A'
        : data[index].transferDetails.embryoTransferredData[0].culture;
    }
    if (key === 'noOfTransferredEmbryos') {
      return data[index].transferDetails.embryoTransferredData.length;
    }
    console.log(index, key);
    if (key === 'gradingOfTransferredEmbryos') {
      const output = ['N/A', 'N/A', 'N/A'];

      for (
        let i = 0;
        i < data[index].transferDetails.embryoTransferredData.length;
        i++
      ) {
        output[i] =
          data[index].transferDetails.embryoTransferredData[i].grade === ''
            ? 'N/A'
            : data[index].transferDetails.embryoTransferredData[i].grade;
      }

      return output;
    }
    if (key === 'lah' || key === 'eg') {
      const checkboxes = data[index].transferDetails.additionalRequirement;

      for (let i = 0; i < checkboxes.length; i++) {
        if (
          key === 'lah' &&
          checkboxes[i].name === 'LAH' &&
          checkboxes[i].checked
        ) {
          return '1';
        }

        if (
          key === 'eg' &&
          checkboxes[i].name === 'Embryo Glue' &&
          checkboxes[i].checked
        ) {
          return '1';
        }
      }
      return '0';
    }

    return data[index].transferDetails[key] ?? 'N/A';
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={14}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            EMBRYO TRANSFER DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            Embryo Transfer (Yes/No)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Day of Embryo Culture
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Transferred Embryos
          </TableCell>
          <TableCell colSpan={3} style={{ fontWeight: 700 }}>
            <div style={{ width: '220px' }}>Grading of Transferred Embryos</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>LAH</TableCell>
          <TableCell style={{ fontWeight: 700 }}>EG</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Comments</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Endometrial Thickness (mm)
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Embryologist Performed ET
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Consultant Performed ET
          </TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            ET: (Easy/Difficult)
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={3}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell>
            <div style={{ height: '20px' }}></div>
          </TableCell>
          <TableCell colSpan={8}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('embryoTransfer', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('dayOfEmbryoCulture', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfTransferredEmbryos', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradingOfTransferredEmbryos', index)[0]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradingOfTransferredEmbryos', index)[1]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradingOfTransferredEmbryos', index)[2]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('lah', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('eg', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('remarks', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('EndometrialThickness', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('embryologist', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('clinician', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('transferDetails', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuTransferDetailsTable;
